import Router from 'next/router';
import {createSlug} from 'src/utils/string';
import url from 'url';
import { isIE } from 'src/utils/browser';
import config from 'config/config';

export const navigateTo = (link) => {
  if (typeof window !== 'undefined') {
    window.location.assign(link);
  }
};

export const buildPostQuery = (post, community, extraArgs = '') => {
  const postType = post.postTypeId === config.api.postTypes.POLL ? 'poll' : 'singlePost';
  const postId = post.id || post.postId;
  const communitySlug = community.groupCode || community.slug || community;
  const titleSlug = post.urlEncodedTitle || createSlug(post.title);
  return `/community/${postType}?id=${postId}&context=${communitySlug}&slug=${titleSlug}${extraArgs}`;
};

export const performSearch = async (searchString, community = 'all', communitySlug = null, reloadPage = false, searchType = 'posts') => {
  const query = encodeURIComponent(searchString);
  if (query) {
    if (!!reloadPage && !!isIE()) {
      if (communitySlug) {
        reloadCommunitySearchPage(query, communitySlug, searchType);
      } else {
        reloadSearchPage(query);
      }
    } else {
      switch (searchType) {
        case 'communities':
          redirectToSearchCommunityPage({query});
          break;
        case 'members':
        case 'posts':
        default:
          redirectToSearchPage({query, community, communitySlug, searchType});
          break;
      }
    }
  }
};

export const redirectToSearchPage = ({ query, page = 1, community = 'all', communitySlug = null, searchType = 'posts', sortBy }) => {
  const sort = sortBy && sortBy !== 'most-relevant' ? `&sort=${sortBy}` : '';
  const match = communitySlug
    ? `/community/communitySearch?slug=${communitySlug}&searchType=${searchType}&query=${query}&page=${page}${sort}`
    : `/search?searchType=posts&query=${query}&page=${page}&community=${community}${sort}`;
  const route = communitySlug
    ? `/${communitySlug}/search/${searchType}?query=${query}&page=${page}${sort}`
    : `/search/posts?query=${query}&page=${page}&community=${community}${sort}`;

  Router.push(match, route, { scroll: false });
};

export const reloadSearchPage = (query) => {
  navigateTo(`/search/posts?query=${query}&page=1&community=all`);
};

export const reloadCommunitySearchPage = (query, communitySlug, searchType) => {
  navigateTo(`/${communitySlug}/search/${searchType}?query=${query}&page=1`);
};

export const redirectToSearchCommunityPage = ({query, page = 1}) => {
  Router.push(
    `/search?searchType=communities&query=${query}&page=${page}`,
    `/search/communities?query=${query}&page=${page}`,
    { scroll: false },
  );
};

export const hardReloadPage = () => {
  window.location.reload();
};

export const getUrlParameter = (param) => {
  if (typeof window !== 'undefined') {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
      const parameterName = sURLVariables[i].split('=');
      if (parameterName[0] === param) {
        return parameterName[1];
      }
    }
  }
};

export const getExpectedPostUrl = (post, communitySlug, currentUrl) => {
  const { search } = url.parse(currentUrl, true);
  const queryParams = search || '';
  const privatePrefix = post.isPrivate ? '/private' : '';
  return `/${communitySlug}/posts${privatePrefix}/${post.id}/${post.urlEncodedTitle}${queryParams}`;
};

export const redirectToPostsPage = (communitySlug, filter) => {
  Router.push(
    `/community/communityPosts?slug=${communitySlug}`,
    filter ? `/${communitySlug}/posts#${filter}` : `/${communitySlug}/posts`,
    { shallow: true },
  );
};

export const redirectToPostsTopicPage = (communitySlug, topicName, filter) => {
  Router.push(
    `/community/communityPosts?slug=${communitySlug}&topicName=${topicName}`,
    filter ? `/${communitySlug}/posts/topic/${topicName}#${filter}` : `/${communitySlug}/posts/topic/${topicName}`,
    { shallow: true },
  );
};

export const redirectToPollsPage = (communitySlug) => {
  Router.push(
    `/community/communityPosts?slug=${communitySlug}`,
    `/${communitySlug}/polls`,
    { shallow: true },
  );
};

export const redirectToMembersPage = (communitySlug, filter = 'active', page = 1) => {
  Router.push(
    `/community/communityMembers?slug=${communitySlug}&filter=${filter}&page=${page}`,
    `/${communitySlug}/members?filter=${filter}&page=${page}`,
    { scroll: false },
  );
};

// Removing recipient from URL once it's processed. We don't want to leak 'recipient'
// in referrer for social media actions - e.g. if users click on log in with fb/google
// Shallow routing has to be done after first render, page isn't replaced, only route state is changed
export const removeRecipientFromUrl = () => {
  const queryParamsArray = location.search.substring(1).split('&');
  const newQueryParamsArray = queryParamsArray.filter(param => !param.includes('recipient'));
  const newQueryParamsString = newQueryParamsArray.join('&');
  const newPathname = Router.query.pathname ? Router.query.pathname : '/';
  const newQueryString = newQueryParamsString ? `?${newQueryParamsString}` : '';

  Router.push(
    { pathname: Router.pathname, query: Router.query },
    `${newPathname}${newQueryString}`,
    { shallow: true },
  );
};
